export default __webpack_public_path__ + "static/media/applechips.43a6c620.jpg";